import { Licenses } from '../Data/Licenses.ts'
import { useParams } from '../Providers/ParamsProvider'

const useGetLoadingSpinnerColor = () => {
    const params = useParams()
    const license = params?.license

    const getSpinnerColor = () => {
        switch (license) {
            case Licenses.Ferrodo:
                return 'text-primary'
            case Licenses.TgInstalacje:
                return 'text-danger'
            case Licenses.Hydraulik:
                return 'text-primary'
            default:
                return ''
        }
    }
    return { getSpinnerColor }
}

export default useGetLoadingSpinnerColor